(function () {
  'use strict';

  var STORAGE_KEY = 'flayvr_ami_final_v27';

  function firstName(value) {
    return String(value || '').trim().split(/\s+/)[0] || '';
  }

  function readSavedName() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!raw) return '';
      var state = raw.state || raw;
      return firstName(state.name || state.recipientName || state.customerName || state.firstName || '');
    } catch (error) {
      return '';
    }
  }

  function boot(root) {
    if (!root || root.dataset.workspaceBound === 'true') return;
    root.dataset.workspaceBound = 'true';

    var input = root.querySelector('[data-ami-workspace-input]');
    var send = root.querySelector('[data-ami-workspace-send]');
    var heading = root.querySelector('[data-ami-workspace-heading]');
    var prompts = root.querySelectorAll('[data-ami-workspace-shortcut]');
    var fresh = root.querySelector('[data-ami-workspace-fresh]');

    var name = readSavedName();
    if (heading && name) {
      heading.innerHTML = 'Hey ' + name.replace(/[&<>"']/g, function (ch) {
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
      }) + ', what do you <span>fancy</span> this week?';
    }

    function getApi(callback) {
      var attempts = 0;
      (function wait() {
        var api = root.__flayvrAmi || window.FlayvrAmi;
        if (api && typeof api.workspacePrompt === 'function') {
          callback(api);
          return;
        }
        attempts += 1;
        if (attempts < 80) window.setTimeout(wait, 50);
      })();
    }

    function submitLanding() {
      var value = input ? input.value.trim() : '';
      if (!value) return;
      getApi(function (api) {
        api.workspacePrompt(value);
        if (input) input.value = '';
      });
    }

    if (send) send.addEventListener('click', submitLanding);
    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          submitLanding();
        }
      });
    }

    Array.prototype.forEach.call(prompts, function (button) {
      button.addEventListener('click', function () {
        var key = button.getAttribute('data-ami-workspace-shortcut');
        getApi(function (api) { api.workspaceShortcut(key); });
      });
    });

    if (fresh) {
      fresh.addEventListener('click', function () {
        getApi(function (api) { api.startFresh(); });
      });
    }
  }

  function bootAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-ami-workspace]'), boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); }, { once: true });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootAll(event.target || document);
  });
})();
